import React from 'react';
import './NewSortPage.css';
import '@shopify/polaris/dist/styles.css';
import Sort from '../components/Sort';
import AuthenticatedPage from '../components/AuthenticatedPage';

function NewSortPage() {
  return (
    <AuthenticatedPage>
      {shopOrigin => <Sort shopOrigin={shopOrigin} type="new" />}
    </AuthenticatedPage>
  );
}

export default NewSortPage;
